import { render, staticRenderFns } from "./LowPriorityComponents.vue?vue&type=template&id=4bcd5294"
import script from "./LowPriorityComponents.vue?vue&type=script&setup=true&lang=ts"
export * from "./LowPriorityComponents.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports